import { AvailableTabs } from 'constants/SidebarTabs';
import { NormalizedLoad } from 'types/Load';

import { getCurrentUrl } from './current-url';
import { TMSHost } from './interface';

export function isMercuryGateBoomiTmsUrl(originOrUrl: string): boolean {
  return originOrUrl.includes('mercurygate.net');
}

// Execution Load board (list) and load detail drawer/routes for Kenco MG web UI.
export function isMercuryGateBoomiLoadBoardUrl(url: string): boolean {
  return (
    isMercuryGateBoomiTmsUrl(url) &&
    (/#\/loadBoard\/el(?:\/|$|\?)/i.test(url) ||
      /\/loadBoard\/el(?:\/|$|\?)/i.test(url))
  );
}

/**
 * MercuryGate via Boomi (Kenco). Browser auto-detect scrapes Load Primary / Shipping
 * Order from the MG load board UI; host URL parsers stay empty (IDs are not in the path).
 *
 * freightTrackingID ↔ primary Shipping Order (e.g. KTMSO…)
 * externalTMSID ↔ MG MasterBillOfLading internalId / OID (persisted for BE matching;
 *   hidden in Load Info UI — empty moniker)
 * customer.refNumber ↔ Load Primary / LD # (shown in UI as BOL; DB customer_ref_number)
 */
export class MercuryGateBoomi implements TMSHost {
  private getCurrentUrl: () => string;

  constructor(getCurrentUrlFn?: () => string) {
    this.getCurrentUrl = getCurrentUrlFn || getCurrentUrl;
  }

  getFieldMoniker(key: keyof NormalizedLoad): string {
    switch (key) {
      case 'externalTMSID':
        return '';
      case 'freightTrackingID':
        return 'Shipping Order';
      default:
        return '';
    }
  }

  parseFreightTrackingID(): string {
    return '';
  }

  parseExternalTMSID(): string {
    return '';
  }

  determineDefaultLoadTab(): AvailableTabs {
    return AvailableTabs.LoadInformation;
  }

  shouldShowDrumkitOpener(): boolean {
    return isMercuryGateBoomiLoadBoardUrl(this.getCurrentUrl());
  }
}
